import { useReducer } from "react";
import { InlineEditorContext } from "./InlineEditorContext";
import { InlineEditorReducer } from "./InlineEditorReducer";
import { initialState } from "./InlineEditorState";

export interface InlineEditorContextProps {
    children: JSX.Element | JSX.Element[];
}

export const InlineEditorProvider = ({ children }: InlineEditorContextProps) => {
    const [state, dispatch] = useReducer(InlineEditorReducer, initialState);

    return <InlineEditorContext.Provider value={{ state, dispatch }}> {children}</InlineEditorContext.Provider>;
};
